module.exports = __webpack_public_path__ + "static/media/etat-sieste-grey.3466e109.svg";